import '~app/sentry';

import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';

import { config } from '~app/config';
import { ApiProvider, PortalQueryClientProvider } from '~app/providers';
import { router } from '~app/router';

import { AuthApiProvider } from '~domains/auth';

import { initAmpli } from '~entities/ampli';
import { logger } from '~entities/logger';

import { WebRequestClient } from '~shared/api/scp/client/web-request/web-request';
import { getAwsWafDomains } from '~shared/lib/aws-waf';
import { ConfirmationProvider } from '~shared/ui/confirmation';

import log from '@tinkoff/request-plugin-log';

import { Toaster } from '@breezeventures/ui-kit/toast';
import { initAwsWaf } from '@breezeventures/web-ph-aws-waf-tools/init-aws-waf';
import { Notifications, NotificationsProvider } from '@pfa/front-notifications';

import './globals.css';
import './index.css';

if (config.environment !== 'local') {
  initAwsWaf({
    cookieDomainList: getAwsWafDomains(),
    env: config.environment === 'prod' ? 'prod' : 'test',
  });
}

initAmpli();

const root = document.getElementById('root') as HTMLElement;

// window.msw = {
//   ...(window.msw ?? {}),
//   initialHandlersOverrides: {
//     checkPartnerSelfie: {
//       scenario: 'has-selfie',
//     },
//     // getPartnerApplicationsByPerson: {
//     //   payload: [],
//     // },
//   },
// };

const enableMocking = config.isMockingEnabled || !!window.TURN_ON_MSW;

const startMocking = enableMocking
  ? async () => {
      const [{ handlers }, { setupMocking }] = await Promise.all([
        import('~app/mocks'),
        import('~shared/msw-kit'),
      ]);
      return setupMocking({ enabled: true, handlers });
    }
  : () => Promise.resolve();

startMocking()
  .then(() => {
    ReactDOM.createRoot(root).render(
      // <React.StrictMode>
      <ApiProvider
        config={config}
        scpClient={
          new WebRequestClient({
            plugins: [log({ name: 'client-api', logger })],
          })
        }
      >
        <NotificationsProvider>
          <ConfirmationProvider>
            <Notifications offsetTop={20} reverse />
            <Toaster position="top-right" />
            <AuthApiProvider>
              <PortalQueryClientProvider>
                <RouterProvider router={router} />
              </PortalQueryClientProvider>
            </AuthApiProvider>
          </ConfirmationProvider>
        </NotificationsProvider>
      </ApiProvider>
      // </React.StrictMode>
    );
  })
  .catch(() => {
    // Error handling
  });
